import { useQuery } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { keys } from './frameCompany.keys';

export function useGetFrameCompanyMonitor(orgNumber: string | undefined) {
  const getApi = useApi();

  const getFrameCompanyMonitor = async () => {
    if (!orgNumber) return null;

    const api = await getApi();

    const res = await api.creditMonitoringGetCreditMonitoringForCompany(
      orgNumber
    );
    return res.data;
  };

  const query = useQuery({
    queryKey: keys.monitor(orgNumber + 'monitor'),
    queryFn: getFrameCompanyMonitor,
    keepPreviousData: false,
  });

  return {
    ...query,
  };
}
